/**
 * @generated SignedSource<<cf4f6393b02d72e3cbc91c21b0289e9d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PopularSearchesSitemapLayout_viewer$data = {
  readonly popularSearchesSitemap: {
    readonly breadcrumbs: ReadonlyArray<{
      readonly isLinkable: boolean | null;
      readonly path: string | null;
      readonly text: string | null;
    }> | null;
    readonly categoryName: string | null;
    readonly descendantCategories: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"PopularSearchesSitemapLinksBlock_links">;
    }> | null;
    readonly mostPopularBuyPages: {
      readonly " $fragmentSpreads": FragmentRefs<"PopularSearchesSitemapLinksBlock_connectionLinks">;
    } | null;
    readonly otherPopularBuyPages: {
      readonly numberOfPages: number | null;
      readonly " $fragmentSpreads": FragmentRefs<"PopularSearchesSitemapLinksBlock_connectionLinks">;
    } | null;
  } | null;
  readonly " $fragmentType": "PopularSearchesSitemapLayout_viewer";
};
export type PopularSearchesSitemapLayout_viewer$key = {
  readonly " $data"?: PopularSearchesSitemapLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PopularSearchesSitemapLayout_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "PopularSearchesSitemapLinksBlock_connectionLinks"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "page"
    },
    {
      "kind": "RootArgument",
      "name": "uriRef"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PopularSearchesSitemapLayout_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "uriRef",
          "variableName": "uriRef"
        }
      ],
      "concreteType": "PopularSearchesSitemapType",
      "kind": "LinkedField",
      "name": "popularSearchesSitemap",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "categoryName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "breadcrumbs",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isLinkable",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "mostPopularBuyPages",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 40
            }
          ],
          "concreteType": "PopularBuyPagesConnection",
          "kind": "LinkedField",
          "name": "popularBuyPages",
          "plural": false,
          "selections": [
            (v0/*:: as any*/)
          ],
          "storageKey": "popularBuyPages(first:40)"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "descendantCategories",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PopularSearchesSitemapLinksBlock_links"
            }
          ],
          "storageKey": null
        },
        {
          "alias": "otherPopularBuyPages",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 200
            },
            {
              "kind": "Variable",
              "name": "page",
              "variableName": "page"
            },
            {
              "kind": "Literal",
              "name": "pageStartOffset",
              "value": 40
            }
          ],
          "concreteType": "PopularBuyPagesConnection",
          "kind": "LinkedField",
          "name": "popularBuyPages",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "numberOfPages",
              "storageKey": null
            },
            (v0/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "da607569e6d325c055eb6979445e2f55";

export default node;
